import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { Separator } from "@/components/ui/separator";
import { Zap, ArrowRight, CircleCheck } from "lucide-react";
const capabilities = ["Kansas City Local Ownership", "Rapid Field Execution", "Certified Technicians", "End-to-End Project Management"];
export default function VendorTrust() {
  return <section id="vendortrust" className="bg-primary py-24 relative overflow-hidden">
      {}
      <div className="absolute inset-0 opacity-10 pointer-events-none">
        <div className="absolute top-0 left-1/4 w-px h-full bg-gradient-to-b from-transparent via-primary-foreground to-transparent" />
        <div className="absolute top-0 right-1/4 w-px h-full bg-gradient-to-b from-transparent via-primary-foreground to-transparent" />
        <div className="absolute top-1/3 left-0 w-full h-px bg-gradient-to-r from-transparent via-primary-foreground to-transparent" />
      </div>

      <div className="container mx-auto px-4 relative z-10">
        <div className="max-w-3xl mx-auto text-center mb-16">
          <Badge variant="outline" className="mb-6 border-primary-foreground/30 text-primary-foreground bg-primary-foreground/10 px-4 py-1.5 text-sm font-mono">
            <Zap className="w-4 h-4 mr-2 text-primary-foreground" />
            Premium Sourcing & Execution
          </Badge>
          <h2 className="font-default text-4xl md:text-5xl font-bold text-background mb-6 tracking-tight">
            Engineered for Reliability. <br className="hidden md:block" />
            Powered by <span className="text-primary-foreground">Industry Leaders.</span>
          </h2>
          <p className="text-background/70 text-lg md:text-xl max-w-2xl mx-auto font-sans">
            As a Kansas City local, VOLTEX combines rapid field execution with top-tier equipment from the most trusted names in low-voltage and IT infrastructure.
          </p>
        </div>

        <Separator className="bg-background/10 mb-16" />

        {}
        <div className="flex flex-col lg:flex-row items-center justify-between gap-10 bg-background/5 border border-background/10 rounded-xl p-8 md:p-12 backdrop-blur-sm">
          <div className="flex-1">
            <h3 className="font-default text-2xl font-bold text-background mb-6">
              Ready for your next project?
            </h3>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              {capabilities.map((cap, i) => <div key={i} data-index={i} className="flex items-center gap-3">
                  <CircleCheck className="w-5 h-5 text-primary-foreground shrink-0" />
                  <span className="text-background/80 font-medium">{cap}</span>
                </div>)}
            </div>
          </div>
          
          <div className="flex flex-col sm:flex-row gap-4 w-full lg:w-auto shrink-0">
            <Link to="/ContactPage">
              <Button size="lg" className="w-full sm:w-auto bg-primary-foreground text-primary hover:bg-primary-foreground/90 font-bold text-base h-14 px-8 shadow-lg shadow-primary-foreground/20">
                Request Site Survey
                <ArrowRight className="w-5 h-5 ml-2" />
              </Button>
            </Link>
            <Link to="/ServicesPage">
              <Button size="lg" variant="outline" className="w-full sm:w-auto border-background/20 text-background hover:bg-background/10 hover:text-background h-14 px-8">
                View All Services
              </Button>
            </Link>
          </div>
        </div>
      </div>
    </section>;
}